import styled from '@emotion/styled';

export const LoadingWrapper = styled.div`
  & > div {
    margin: 0;
  }
`;
